import { render, staticRenderFns } from "./FinalDetails.vue?vue&type=template&id=54ee2529&scoped=true"
import script from "./FinalDetails.vue?vue&type=script&lang=js"
export * from "./FinalDetails.vue?vue&type=script&lang=js"
import style0 from "./FinalDetails.vue?vue&type=style&index=0&id=54ee2529&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ee2529",
  null
  
)

export default component.exports